"use client"

import { ErrorPage } from "@local/ui/src/components/ErrorPage"

/**
 * `global-error.tsx` replaces the entire document when the root layout itself
 * fails, so it has to supply its own `<html>` and `<body>`. The root layout's
 * are gone by the time this renders.
 */
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string }
  retry: () => void
}) {
  return (
    <html lang="en">
      <body>
        <ErrorPage error={error} retry={retry} />
      </body>
    </html>
  )
}
